
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-48f53d8d&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LoanSummary.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LoanSummary.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-48f53d8d!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LoanSummary.vue"),
  /* scopeId */
  "data-v-48f53d8d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/Loan/LoanSummary.vue
// module id = 690
// module chunks = 0